//获取当前时间格式  单位是10:10:10  参数传入是s秒
export function formatDuring(mss) {
  var hour = parseInt(mss / 60 / 60);
  var minutes = parseInt((mss - hour * 60 * 60) / 60);
  var seconds = mss - hour * 60 * 60 - 60 * minutes;
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hour + ":" + minutes + ":" + seconds;
}
//根据当前时间转换成秒  返回秒 参数10:10:10 或者 0：8:10 0:29:52
export function formatSends(item) {
  let res = 0;
  let i = item.split(":");
  if (i[0] > 0) {
    res += i[0] * 60 * 60;
  }
  if (i[1] > 0) {
    res = Number(res) + i[1] * 60;
  }
  if (i[2] > 0) {
    res = Number(res) + Number(i[2]);
  }
  return res;
}
function dateFormat(date) {
  console.log(showTime(date.getHours()));
  var year = date.getFullYear(); // 年
  var month = showTime(date.getMonth() + 1); // 月
  var week = showTime(date.getDay()); // 星期
  var day = showTime(date.getDate()); // 日
  var hours = showTime(date.getHours()); // 小时
  var minutes = showTime(date.getMinutes()); // 分钟
  var second = showTime(date.getSeconds()); // 秒
  var str = "";
  str =
    str +
    year +
    "-" +
    month +
    "-" +
    week +
    "-" +
    day +
    "-" +
    hours +
    "-" +
    minutes +
    "-" +
    second;
  return str;
}

// 封装一个不够两位数就补零的函数
function showTime(t) {
  var time;
  time = t > 10 ? t : "0" + t;
  return time;
}